<div class="add-attachments">
  <label
    class="add-attachment"
    [attr.for]="readOnlyAccess ? null : attachmentSelectId"
    [attr.disabled]="readOnlyAccess || disabled || null"
    (click)="onUploadAttempt($event)"
    [ngClass]="{ 'icon-only': hideLabel && icon }"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
  >
    <app-icon *ngIf="icon" class="icon" [icon]="icon"> </app-icon>

    <span [hidden]="hideLabel">
      {{ label }}
    </span>
  </label>

  <input
    type="file"
    [attr.accept]="acceptableFileTypes?.join(',')"
    [attr.id]="attachmentSelectId"
    hidden
    [multiple]="enableMultipleFiles"
    (click)="onUploadAttempt($event)"
    (change)="onAddFiles($event)"
  />

  <app-premium-icon
    *ngIf="showFeatureHighlight"
    class="feature-highlight"
    (click)="showFeatureHighlightDialog()"
  >
  </app-premium-icon>
</div>

<app-error-message [errorMessage]="errorMessage"></app-error-message>
